export default __webpack_public_path__ + "static/media/pantai-hospital-logo.91ff569b.png";